import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useLocalizedNavigate } from '@/shared/hooks'
import { Loader2, AlertCircle, ArrowLeft } from 'lucide-react'
import { Sidebar } from '@/shared/components'
import { TeamExchangeZone } from '../components'
import { useTeamByShortId } from '../hooks'

export function TeamExchangePage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { shortId } = useParams<{ shortId: string }>()

  const { data: team, isLoading, error } = useTeamByShortId(shortId)

  // Loading state
  if (isLoading) {
    return (
      <div className="flex h-screen bg-background">
        <Sidebar />
        <main className="flex flex-1 items-center justify-center bg-background-secondary">
          <Loader2 className="h-8 w-8 animate-spin text-foreground-muted" />
        </main>
      </div>
    )
  }

  // Error state
  if (error || !team) {
    return (
      <div className="flex h-screen bg-background">
        <Sidebar />
        <main className="flex flex-1 flex-col items-center justify-center gap-4 bg-background-secondary">
          <AlertCircle className="h-12 w-12 text-destructive" />
          <p className="text-foreground-muted">{t('common.error')}</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 text-sm text-accent hover:underline"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('common.back')}
          </button>
        </main>
      </div>
    )
  }

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />

      <main className="flex flex-1 flex-col overflow-hidden bg-background-secondary">
        {/* Header */}
        <div className="flex items-center gap-4 px-8 py-6">
          {/* Back button */}
          <button
            onClick={() => navigate(-1)}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-white text-foreground transition-colors hover:bg-background-secondary"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>

          {/* Title */}
          <div className="flex flex-col gap-1">
            <span className="text-xs text-foreground-muted">{team.name}</span>
            <h1 className="text-xl font-semibold text-foreground">
              {t('exchange.teamTitle')}
            </h1>
          </div>
        </div>

        {/* Content - Exchange Zone centered */}
        <div className="flex flex-1 items-start justify-center overflow-hidden px-8 pb-8">
          <TeamExchangeZone
            teamId={team.id}
            subtitle={t('exchange.teamSubtitle')}
          />
        </div>
      </main>
    </div>
  )
}
